"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueWrapper = void 0;
const deserializationError_1 = require("./deserializationError");
const objectDeserializer_1 = require("./objectDeserializer");
class ValueWrapper {
    constructor(path, value) {
        this.path = path;
        this.value = value;
    }
    /**
     * Returns value as is.
     */
    get asAny() {
        return this.value;
    }
    /**
     * Checks and returns value as boolean.
     *
     * @throws DeserializationError
     */
    get asBool() {
        if (typeof this.value !== 'boolean')
            throw new deserializationError_1.DeserializationError(this.path, 'Not a boolean');
        return this.value;
    }
    /**
     * Checks and returns value as string.
     *
     * @throws DeserializationError
     */
    get asString() {
        if (typeof this.value !== 'string')
            throw new deserializationError_1.DeserializationError(this.path, 'Not a string');
        return this.value;
    }
    /**
     * Checks and returns value as number.
     *
     * @throws DeserializationError
     */
    get asNumber() {
        if (typeof this.value !== 'number')
            throw new deserializationError_1.DeserializationError(this.path, 'Not a number');
        return this.value;
    }
    /**
     * Checks and returns value as date.
     *
     * @throws DeserializationError
     */
    get asDate() {
        if (typeof this.value !== 'string')
            throw new deserializationError_1.DeserializationError(this.path, 'Not a string');
        const date = new Date(this.value);
        if (!date.getDate())
            throw new deserializationError_1.DeserializationError(this.path, 'Not a date');
        return new Date(this.value);
    }
    /**
     * Convert raw value to target type with provided mapper function.
     *
     * @throws DeserializationError
     */
    as(mapper) {
        return mapper(this.value, this.path);
    }
    /**
     * Converts raw value to array of target type with provided mapper function.
     *
     * @throws DeserializationError
     */
    asArray(mapper) {
        if (!Array.isArray(this.value))
            throw new deserializationError_1.DeserializationError(this.path, 'Not an array');
        return this.value.map((v) => mapper(v, this.path));
    }
    /**
     * Deserialize value to the target type with a provided object mapper.
     *
     * @param mapper
     */
    asObject(mapper) {
        const obj = new objectDeserializer_1.ObjectDeserializer(this.value, this.path);
        return mapper(obj);
    }
    /**
     * Deserialize value to the array of target objects with a provided object mapper.
     *
     * @param mapper
     */
    asArrayOfObjects(mapper) {
        return this.asArray((v, p) => mapper(new objectDeserializer_1.ObjectDeserializer(v, p)));
    }
    /**
     * Deserialize value to the array of optional target objects with a provided object mapper.
     *
     * @param mapper
     */
    asArrayOfOptionalObjects(mapper) {
        return this.asArray((v, p) => (v ? mapper(new objectDeserializer_1.ObjectDeserializer(v, p)) : undefined));
    }
    /**
     * Deserialize value to the enum value
     *
     * @param enumType
     */
    asEnum(enumType) {
        const key = this.value;
        const result = enumType[key];
        if (result === undefined) {
            throw new deserializationError_1.DeserializationError(this.path, `Unregistered enum value: ${this.value}`);
        }
        return result;
    }
}
exports.ValueWrapper = ValueWrapper;
